import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Bell } from 'lucide-react'
import { useMe } from '@/api/hooks'
import { useUnreadCount } from '@/api/notifications'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/format'

/** Top-bar entry to the notification center with the unread count (never colour alone: the number is text). */
export function NotificationBell() {
  const { t } = useTranslation()
  const me = useMe().data
  const count = useUnreadCount(Boolean(me)).data ?? 0
  return (
    <Link
      to="/notifications"
      aria-label={count > 0 ? t('notifications.bellUnread', { count }) : t('notifications.bell')}
      className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }), 'relative')}
    >
      <Bell aria-hidden className="size-5" />
      {count > 0 ? (
        <span data-testid="unread-count" aria-hidden className="absolute right-0.5 top-0.5 inline-flex min-w-5 items-center justify-center rounded-full bg-action px-1 text-caption font-semibold leading-5 text-on-action">
          {count > 99 ? '99+' : formatNumber(count)}
        </span>
      ) : null}
    </Link>
  )
}
